<div class="container-fluid">
    <router-outlet></router-outlet>
</div>
<div class="w-100 text-end fw-lighter fst-italic pe-5 version">
    Guest 360 v{{appVersion}}
</div>
<val-toast />